<template>
  <w-flex justify-center align-center>
          <div class="w-card__content content-hardcode">

              <table class="table-dashboard" width="100%">
                  <thead>
                  <tr>
                      <td >No</td>
                      <td >Tindakan</td>
                      <td >Pengguna</td>
                      <td >Tarikh</td>
                      <td>Catatan</td>
                  </tr>
                  </thead>
                  <tbody>
                  
                      <tr v-for="dt, index in jejak_audit">
                          <td class="w-table__cell text-left">
                              {{(index + 1)}}
                          </td>
                          <td class="w-table__cell text-left">
                              {{dt.tindakan_keterangan}}
                          </td>
                          <td class="w-table__cell text-left">
                              {{dt.user_nama}}
                          </td>
                          <td class="w-table__cell text-left">
                              {{dt.tarikh}}
                          </td>
                          <td class="w-table__cell text-left">
                              {{dt.catatan}}
                          </td>
                      </tr>
                      <tr v-if="jejak_audit.length == 0">
                          <td class="w-table__cell text-left" colspan="5">
                          </td>
                      </tr>
                  </tbody>
                  
              </table>
            </div>
          </w-flex>
</template>

<script>
export default {
  name: 'z-jejak-audit',
  inheritAttrs: false,
  props: {
    
    jejak_audit: [Array, Object, String],
  },
  data: () => ({
    
  }),
  methods: {
    
  },
  computed: {
    
  }
}
</script>

<style>


</style>